import * as React from "react";
import {
  Divider,
  Grid,
  ListItemIcon,
  ListItemText,
  styled,
  Tooltip
} from "@mui/material";
import { IconChevronRight } from "@tabler/icons-react";
import MaxcoreBallow from "@icons-rf/maxcore-ballow.svg?react";
import MaxcoreLogo from "@icons-rf/maxcore-logo.svg?react";
import useMenuItemsSideBar from "@rf-hooks/useMenuItemsSideBar";
import { useSidebar } from "../context/SidebarContext";
import {
  ContentRender,
  ToggleSideBarButton,
  ListRender,
  SideBarItem
} from "../styles/LayoutStyles";
import ENVIRONMENT_VAR from "@/src-refactor/modules/shared/model/const/env/env.const";
import MxTooltipNormal from "@rf-l1/tooltip/MxTooltipNormal";

interface MenuItem {
  icon: React.ReactNode;
  label: string;
  onClick?: () => void;
}

const SideBar: React.FC = () => {
  const { closeSideBar, toggleSideBar, isOpen } = useSidebar();
  const items = useMenuItemsSideBar();
  const { VERSION, NODE_ENV } = ENVIRONMENT_VAR;

  const handleSelectItem = (item: MenuItem) => {
    item.onClick?.();
    closeSideBar();
  };

  return (
    <ContentRender container id="side-bar-render">
      <ToggleSideBarButton
        data-testid="toggle-side-bar-button"
        className="toggle-side-bar-button"
        onClick={toggleSideBar}
      >
        <IconChevronRight size={25} />
      </ToggleSideBarButton>
      <Grid container item xs={12} justifyContent="center" alignItems="center">
        <Grid item xs="auto" className="maxcore-ballow">
          <MaxcoreBallow />
        </Grid>
        <Grid item xs="auto" className="maxcore-logo">
          <MaxcoreLogo />
        </Grid>
      </Grid>

      <Grid
        item
        xs={12}
        sx={{
          maxHeight: "90dvh",
          overflowY: "auto",
          minHeight: "90dvh"
        }}
      >
        <ListRender data-testid="side-bar-list">
          {items.map((item: MenuItem, index: number) => (
            <div key={index} data-testid={`side-bar-item-${item.label}`}>
              {isOpen ? (
                <SideBarItem
                  onClick={() => handleSelectItem(item)}
                  data-testid={`side-bar-item-${item.label}-button`}
                >
                  <ListItemIcon>{item.icon}</ListItemIcon>
                  <ListItemText primary={item.label} />
                </SideBarItem>
              ) : (
                <MxTooltipNormal label={item.label} placement="right">
                  <SideBarItem
                    onClick={() => handleSelectItem(item)}
                    data-testid={`side-bar-item-${item.label}-button`}
                  >
                    <ListItemIcon>{item.icon}</ListItemIcon>
                    <ListItemText primary={item.label} />
                  </SideBarItem>
                </MxTooltipNormal>
              )}
              {index !== items.length - 1 && <Divider />}
            </div>
          ))}
        </ListRender>
        <Version key={"version"}>
          v{VERSION} - {NODE_ENV}
        </Version>
      </Grid>
    </ContentRender>
  );
};

export default SideBar;

const Version = styled("div")(({ theme }) => ({
  color: "white",
  padding: "10px 12px",
  fontSize: "7px",
  fontFamily: theme.typography.fontFamily,
  fontWeight: 500,
  width: "100%",
  textAlign: "center",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis"
}));
